import { render } from "./NavbarBasic.vue?vue&type=template&id=16b69a2c&ts=true"
import script from "./NavbarBasic.vue?vue&type=script&lang=ts"
export * from "./NavbarBasic.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__